/**
 * 그룹 관리 페이지
 * - 그룹 목록 테이블
 * - 그룹 생성 모달 (admin만)
 * - 수정/삭제 모달
 */

import React, { useState } from 'react';
import { Card } from 'antd';
import { GroupTable } from './components/GroupTable';
import { GroupCreateModal } from './components/GroupCreateModal';
import { GroupEditModal } from './components/GroupEditModal';
import { GroupDeleteConfirm } from './components/GroupDeleteConfirm';
import type { Group, GroupWithStats } from '../../types/group';

export const GroupsPage: React.FC = () => {
  // 모달 상태 관리
  const [createModalOpen, setCreateModalOpen] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  // 선택된 그룹 상태
  const [selectedGroup, setSelectedGroup] = useState<Group | null>(null);

  // 테이블 새로고침 트리거
  const [refreshKey, setRefreshKey] = useState(0);

  /**
   * 테이블 새로고침
   */
  const handleRefresh = () => {
    setRefreshKey((prev) => prev + 1);
  };

  /**
   * 그룹 생성 모달 열기
   */
  const handleCreateGroup = () => {
    setCreateModalOpen(true);
  };

  /**
   * 그룹 수정 모달 열기
   */
  const handleEdit = (group: GroupWithStats) => {
    setSelectedGroup(group);
    setEditModalOpen(true);
  };

  /**
   * 그룹 삭제 모달 열기
   */
  const handleDelete = (group: GroupWithStats) => {
    setSelectedGroup(group);
    setDeleteModalOpen(true);
  };

  /**
   * 모달 성공 시 처리 (테이블 새로고침)
   */
  const handleModalSuccess = () => {
    handleRefresh();
  };

  return (
    <div style={{ padding: '24px' }}>
      <Card title="그룹 관리">
        <GroupTable
          key={refreshKey}
          onCreateGroup={handleCreateGroup}
          onEdit={handleEdit}
          onDelete={handleDelete}
        />
      </Card>

      {/* 그룹 생성 모달 */}
      <GroupCreateModal
        open={createModalOpen}
        onClose={() => setCreateModalOpen(false)}
        onSuccess={handleModalSuccess}
      />

      {/* 그룹 수정 모달 */}
      <GroupEditModal
        open={editModalOpen}
        group={selectedGroup}
        onClose={() => setEditModalOpen(false)}
        onSuccess={handleModalSuccess}
      />

      {/* 그룹 삭제 확인 모달 */}
      <GroupDeleteConfirm
        open={deleteModalOpen}
        group={selectedGroup}
        onClose={() => setDeleteModalOpen(false)}
        onSuccess={handleModalSuccess}
      />
    </div>
  );
};

export default GroupsPage;
